export function coverEveryCase<T extends string, U>(
  arg: T,
  cases: Record<T, U | (() => U)>
): U {
  const foundCase = cases[arg];
  const result = typeof foundCase === 'function' ? foundCase() : foundCase;
  return result;
}

type PartialRecord<K extends string | number | symbol, T> = { [P in K]?: T };

export function coverCases<T extends string | number, U>(
  arg: T,
  cases: PartialRecord<T, U | (() => U)>,
  defaultCase: () => U
): U {
  const foundCase = cases[arg];
  if (foundCase) {
    const result = typeof foundCase === 'function' ? foundCase() : foundCase;
    return result;
  }
  return defaultCase();
}

export async function wait(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export function noop(): void {}

export function noopAsync(): Promise<void> {
  return Promise.resolve();
}

export function getQueryParams(url: string): { [k: string]: string } {
  const queryParams: { [k: string]: string } = {};

  // Extract the query string from the URL
  const queryString = url.split('?')[1];
  if (!queryString) {
    return queryParams;
  }

  // Split the query string into individual key-value pairs
  const pairs = queryString.split('&');

  // Iterate over each key-value pair and add it to the result object
  for (const pair of pairs) {
    const [key, value] = pair.split('=');
    queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
  }

  return queryParams;
}
